"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _passengerSelectionStepper = _interopRequireDefault(require("@airasia/phoenix-components/components/PassengerSelectionStepper/passengerSelectionStepper.proptypes"));

var _constant2 = require("./constant"); // eslint-disable-next-line max-len


var _default = {
  PropTypes: {
    passengerStepperConfig: (0, _propTypes.shape)(_passengerSelectionStepper.default.PropTypes),
    travelClassConfig: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      title: _propTypes.string,
      value: _propTypes.any
    })),
    translations: (0, _propTypes.shape)({
      mixTravelTitle: _propTypes.string,
      mixTravelSubtitle: _propTypes.string,
      flightPaxSelectorTitle: _propTypes.object,
      flightPaxSelectorWithTravelClassTitle: _propTypes.object,
      doneButtonLabel: _propTypes.string,
      flightPaxSelectorMainTitle: _propTypes.string,
      travelClassTitle: _propTypes.string
    }),
    defaultTravelClass: _propTypes.string,
    isMixTravelClass: _propTypes.bool,
    showTravelClass: _propTypes.bool,
    showMixClassCheckbox: _propTypes.bool,
    isMobile: _propTypes.bool,
    onDone: _propTypes.func,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    hasBanner: _propTypes.bool,
    bannerData: (0, _propTypes.shape)({
      imageURL: _propTypes.string,
      headline: _propTypes.string,
      subheadline: _propTypes.string,
      tags: [{
        label: _propTypes.string,
        url: _propTypes.string,
        color: _propTypes.string,
        backgroundColor: _propTypes.string
      }]
    })
  },
  DefaultProps: {
    passengerStepperConfig: _constant2.DEFAULT_PASSENGER_STEPPER_CONFIG,
    travelClassConfig: _constant2.DEFAULT_TRAVEL_CLASS_CONFIG,
    onDone: function onDone() {},
    translations: {
      mixTravelTitle: _constant2.DEFAULT_TRANSLATIONS.mixTravelTitle,
      mixTravelSubtitle: _constant2.DEFAULT_TRANSLATIONS.mixTravelSubtitle,
      flightPaxSelectorTitle: _constant2.DEFAULT_TRANSLATIONS.flightPaxSelectorTitle,
      flightPaxSelectorWithTravelClassTitle: _constant2.DEFAULT_TRANSLATIONS.flightPaxSelectorWithTravelClassTitle,
      doneButtonLabel: _constant2.DEFAULT_TRANSLATIONS.doneButtonLabel,
      flightPaxSelectorMainTitle: _constant2.DEFAULT_TRANSLATIONS.flightPaxSelectorMainTitle,
      travelClassTitle: _constant2.DEFAULT_TRANSLATIONS.travelClassTitle
    },
    theme: _constant.DEFAULT_THEME,
    defaultTravelClass: _constant2.DEFAULT_TRAVEL_CLASS,
    isMixTravelClass: false,
    showTravelClass: false,
    showMixClassCheckbox: false,
    isMobile: false,
    accessible: true,
    hasBanner: false,
    bannerData: {}
  }
};
exports.default = _default;